import styled from '@emotion/styled';
import { spacing } from '../../../../../themes';

export const WizardStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.small};
`;

export const WizardStepTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxsmall};
`;
